var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"show-arrows":""}},_vm._l((10),function(i){return _c('v-tab',{key:i},[_vm._v(" Item "+_vm._s(i)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }